module.exports = __webpack_public_path__ + "static/media/deutschland.282dbd66.svg";